import { render, staticRenderFns } from "./ipBanned.vue?vue&type=template&id=41a526b1&"
import script from "./ipBanned.vue?vue&type=script&lang=js&"
export * from "./ipBanned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41a526b1')) {
      api.createRecord('41a526b1', component.options)
    } else {
      api.reload('41a526b1', component.options)
    }
    module.hot.accept("./ipBanned.vue?vue&type=template&id=41a526b1&", function () {
      api.rerender('41a526b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpCustomerService/ipBanned.vue"
export default component.exports